<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>我的云店</BreadcrumbItem>
          <BreadcrumbItem>资质证书</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
        <p class="header-tool-text">建议上传总代证明、发明专利、获奖证书等</p>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/certificate/addcertificate')">
          <span class="htb-add">+</span>
          <span>添加资质证书</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <template v-if="list && list.items.length">
        <Row :gutter="30">
          <Col style="width:20%;float:left" v-for="(item, index) in list.items" :key="'CertificateInt-' + index">
            <div class="my-item-box">
              <div class="mi-top">
                <div v-if="!item.isShow" class="certificate-show">
                  <i class="icon iconfont icon-hide"></i>
                </div>
                <img :src="item.image" v-if="item.image" />
                <img src="@assets/img/empty.png" v-else />
              </div>
              <div class="mi-title f-tac" :title="item.name">{{item.name}}</div>
              <div class="mi-tool">
                <div class="mi-tool-item z-primary" @click="showEdit(item)">编辑</div>
                <div class="mi-tool-line">|</div>
                <div class="mi-tool-item" v-if="item.isShow" @click="showOff(item)">屏蔽</div>
                <div class="mi-tool-item" v-if="!item.isShow" @click="showOn(item)">显示</div>
                <div class="mi-tool-line">|</div>
                <div class="mi-tool-item">
                  <Poptip
                    confirm
                    placement="top-start"
                    title="确认删除此资质证书吗 ?"
                    @on-ok="delItem(item, index)"
                    @on-cancel="handleClose(index)"
                  >删除</Poptip>
                </div>
                <!-- <div class="mi-tool-item">
                  <Dropdown trigger="custom" :visible="item.visible">
                    <a href="javascript:void(0);" style="color:#808080;" @click="toggleOpen(index)">
                      更多
                      <Icon type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list" style="text-align:center;"> 
                      <DropdownItem v-if="item.isShow" @click.native="showOff(item)">屏蔽</DropdownItem>
                      <DropdownItem v-if="!item.isShow" @click.native="showOn(item)">显示</DropdownItem>
                      <DropdownItem>
                        <Poptip
                          confirm
                          placement="top-start"
                          title="确认删除此资质证书吗 ?"
                          @on-ok="delItem(item, index)"
                          @on-cancel="handleClose(index)"
                        >
                          <div style="width: 100px;">删除</div>
                        </Poptip>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div> -->
              </div>
            </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </template>
      <div class="u-empty" v-else>暂无数据</div>

      <!-- 新增 -->
      <!-- <addCertificate :show="add" @finish="init()" @close="hideAdd()" /> -->
      <!-- 编辑 -->
      <editCertificate :show="edit" :info="editInfo" @finish="init()" @close="hideEdit()" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addCertificate from "./../components/add-certificate.vue";
import editCertificate from "./../components/edit-certificate.vue";
export default {
  // 证书
  name: "certificate",
  data() {
    return {
      // deleted: false,
      edit: false,
      // add: false,
      list: null,
      editInfo: null,

      pageSize: 18,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  components: {
    // addCertificate,
    editCertificate
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getCertificate: "companyModule/getCertificate",
      delCertificate: "companyModule/delCertificate",
      setCertificateShow: "companyModule/setCertificateShow"
    }),
    async init() { 
      let result = await this.getCertificate({
        CompId: this.company.id,
        pageSize: 50,
        pageIndex: this.pageIndex
      });
      if (result) {
        result.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
          c.visible = false;
        });
        this.list = result;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
      }
    },
    async delItem(item) {
      let result = await this.delCertificate(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    // showAdd() {
    //   this.add = true;
    // },
    // hideAdd() {
    //   this.add = false;
    // },
    showEdit(item) {
      // this.edit = true;
      // this.editInfo = item;
      this.$router.push(
        `/exhibition/index/certificate/editCertificate?id=${item.id}`
      );
    },
    hideEdit() {
      this.edit = false;
      this.editInfo = null;
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      
    },
    // 屏蔽
    async showOff(item) {
      let result = await this.setCertificateShow({
        Id: item.id,
        IsShow: false
      });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败");
      }
    },
    // 显示
    async showOn(item) {
      let result = await this.setCertificateShow({ Id: item.id, IsShow: true });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败");
      }
    },

    handleOpen(index) {
      this.list.items[index].visible = true;
    },
    handleClose(index) {
      this.list.items[index].visible = false;
    },
    toggleOpen(index) {
      let visible = this.list.items[index].visible;
      this.list.items[index].visible = !visible;
    }
  }
};
</script>

<style scoped lang="scss">
.certificate-show {
  position: absolute;
  z-index: 999;
  right: 0;
  width: 0;
  height: 0;
  border-width: 20px;
  border-style: solid;
  border-color: #ccc #ccc transparent transparent;
  i {
    position: absolute;
    top: -25px;
    right: -20px;
    color: #fff;
    font-size: 25px;
  }
}
</style> 
